import { isTotpCreateAllowed } from 'utils/plan'

// 인증 코드(OTP) 전역 기본 템플릿 판별 — memo(isMemoTemplate)와 동형인 locale-proof
// readonly+icon 조합. name 은 로케일 번역 title 로 내려오므로 이름 비교는 쓰지 않는다.
// icon 은 'shield-check'(체크 든 방패, 현행) 이며 구 시딩('shield')도 배포 전환기 하위호환
// 으로 함께 인정한다. (관리자 커스텀 shield 아이콘 템플릿은 readonly=0 이라 오탐 없음)
export function isAuthenticatorTemplate(template) {
  return (
    Boolean(template?.readonly) &&
    (template?.icon === 'shield-check' || template?.icon === 'shield')
  )
}

// 숨겨야 하는가 — flag OFF 빌드 또는 (Phase 3 부터) Basic 등급. 픽스처는 전 환경에 시딩되므로
// FE 게이팅이 유일한 노출 제어다. 소비처: 생성 패널 템플릿 셀렉트(helper.js fieldManager),
// admin 콘솔 템플릿 목록(pages/admin/templates). 템플릿은 "생성 진입점"이라 create 계열 게이트.
// 이 모듈은 의존 경량(+utils/plan)으로 유지 — admin 페이지에서 import 해도 무거운 체인 없음.
export function shouldHideAuthenticatorTemplate(template) {
  return !isTotpCreateAllowed() && isAuthenticatorTemplate(template)
}
